import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { buildClassString } from '../StringUtils';
import './style/index.scss';
export class Tooltip extends React.PureComponent {
    render() {
        const { id, content, wrapperClassName, tooltipClassName, place, effect, event, type, border } = this.props;
        const wrapperClassString = buildClassString({
            tooltip__wrapper: true,
            [wrapperClassName]: !!wrapperClassName
        });
        const tooltipClassString = buildClassString({
            tooltip__wrapper: true,
            tooltip__default: !tooltipClassName,
            [tooltipClassName]: !!tooltipClassName
        });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: wrapperClassString, "data-tip": "", "data-for": id }, this.props.children),
            React.createElement(ReactTooltip, { id: id, className: tooltipClassString, place: place || 'top', effect: effect || 'float', event: event || '', border: border !== undefined ? border : true, type: type || 'light' }, content)));
    }
}
